import Logo from "./Logo";
import Footer from "./Footer";

export default function AuthLayout({ children, headerRight }) {
  return (
    <div className="min-h-screen bg-[#FBFCF6] mt-3 flex flex-col">
      {/* Header */}
      <header className="h-16 md:h-20 flex items-center">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between">
          <Logo />
          {headerRight && <div className="hidden sm:flex">{headerRight}</div>}
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center">
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
